import { render, staticRenderFns } from "./EditCategorySidebar.vue?vue&type=template&id=03a34fe5"
import script from "./EditCategorySidebar.vue?vue&type=script&lang=js"
export * from "./EditCategorySidebar.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/animations.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports